import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Typography, useTheme } from "@mui/material";

import { IoLogoJavascript } from "react-icons/io";
import { BiLogoTypescript } from "react-icons/bi";
import { FaReact } from "react-icons/fa";
import { FaAngular } from "react-icons/fa6";
import { FaVuejs } from "react-icons/fa6";
import { FaNode } from "react-icons/fa";
import { FaPython } from "react-icons/fa";
import { FaJava } from "react-icons/fa";
import { SiMysql } from "react-icons/si";
import { SiAmazondynamodb } from "react-icons/si";
import { SiPrisma } from "react-icons/si";
import { BiLogoFirebase } from "react-icons/bi";
import { DiMongodb } from "react-icons/di";

import { FaAws } from "react-icons/fa";
import { SiGooglecloud } from "react-icons/si";
import { SiNetlify } from "react-icons/si";
import { FaDocker } from "react-icons/fa";

export const ToolTabs = () => {
  const [value, setValue] = React.useState("one");
  const theme = useTheme();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const tabItems = {
    one: [
      {
        icon: <IoLogoJavascript style={{ fontSize: 50 }} />,
        label: "JavaScript",
      },
      {
        icon: <BiLogoTypescript style={{ fontSize: 60 }} />,
        label: "TypeScript",
      },
      { icon: <FaReact style={{ fontSize: 60 }} />, label: "React" },
      { icon: <FaAngular style={{ fontSize: 60 }} />, label: "Angular" },
      { icon: <FaVuejs style={{ fontSize: 60 }} />, label: "Vue.js" },
    ],
    two: [
      { icon: <FaNode style={{ fontSize: 60 }} />, label: "Node.js" },
      { icon: <FaPython style={{ fontSize: 60 }} />, label: "Python" },
      { icon: <FaJava style={{ fontSize: 60 }} />, label: "Java" },
    ],
    three: [
      { icon: <DiMongodb style={{ fontSize: 60 }} />, label: "MongoDB" },
      {
        icon: <SiAmazondynamodb style={{ fontSize: 60 }} />,
        label: "DynamoDB",
      },
      { icon: <SiPrisma style={{ fontSize: 60 }} />, label: "Prisma" },
      { icon: <BiLogoFirebase style={{ fontSize: 60 }} />, label: "Firebase" },
      { icon: <SiMysql style={{ fontSize: 60 }} />, label: "MySQL" },
    ],

    four: [
      { icon: <FaAws style={{ fontSize: 60 }} />, label: "AWS" },
      {
        icon: <SiGooglecloud style={{ fontSize: 60 }} />,
        label: "Google Cloud",
      },
      { icon: <SiNetlify style={{ fontSize: 60 }} />, label: "Netlify" },
      { icon: <FaDocker style={{ fontSize: 60 }} />, label: "Docker" },
    ],
  };
  return (
    <>
      <Box
        sx={{
          width: { sm: "100%", md: "60%" },
          textAlign: { sm: "center", md: "center" },
        }}
      >
        <Typography
          component="div"
          variant="body1"
          textAlign="center"
          sx={{
            color:
              theme.palette.mode === "light"
                ? theme.palette.secondary.main
                : "#9043c6",
            fontWeight: "bold",
          }}
        >
          OUR TECH STACKS
        </Typography>
        <Typography
          component="h2"
          variant="h4"
          color="text.primary"
          fontWeight="bold"
          textAlign="center"
          sx={{ lineHeight: { xs: "2.5rem" }, mt: 4, mb: 4 }}
        >
          Technology we work with
        </Typography>
      </Box>

      <Box sx={{ maxWidth: { xs: 320, sm: 480 } }}>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="secondary tabs example"
          centered
        >
          <Tab value="one" label="Frontend" />
          <Tab value="two" label="Backend" />
          <Tab value="three" label="Database" />
          <Tab value="four" label="Infrastructure" />
        </Tabs>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          p: 5,
          m: 1,

          borderRadius: 1,
        }}
      >
        {tabItems[value].map((item, index) => (
          <Box
            sx={{
              margin: "0 30px",
            }}
          >
            {item.icon}
          </Box>
        ))}
      </Box>
    </>
  );
};
